/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { ConfigProvider } from './../config/provider';
import { RxEmitterInstance } from 'common/rxjs/rx-emitter';
import { MessageBusEvents } from 'common/common/constants/message-bus-events';
import { Deferred } from './deferred';

export function WebSocketStream(webSocketFactoryMethod) {
  var connectionDeferred = null;
  var wssUrl = null;
  var websocket = null;
  var lastReceivedMessageID = '0';

  var bcConfig = ConfigProvider().$get();

  var messageHandlers = {
    connect: function () {
      RxEmitterInstance.send(MessageBusEvents.WebSocketConnected, null);

      if (connectionDeferred) {
        connectionDeferred.resolve('onopen');
        connectionDeferred = null;
      }
    },
    redirect: function (method, params) {
      wssUrl = params && params.WebSocketURL;
      _resetInner();
    },
    reconnect: function () {
      _reconnectInner();
    }
  };

  var self = {
    connect: connect,
    close: close,
    send: send,
    sendAck: sendAck,
    reconnect: reconnect,
    reset: reset,
    needPeriodicConnectionReset: false,
    onConnectionLost: function () {
      console.warn('onConnectionLost not implemented');
    }
  };

  function connect(clientInfo, messageCallback) {
    wssUrl = bcConfig.getWebSocketEndpoint();
    _messageCallback = messageCallback;
    // Reset promise object here, as it could have been rejected on a previous connection attempt
    connectionDeferred = null;

    return _connect();
  }

  function close() {
    _unsubscribeWebSocket();
    _innerClose();
  }

  function _innerClose() {
    if (websocket && (websocket.readyState === websocketReadyStates.CONNECTING || websocket.readyState === websocketReadyStates.OPEN)) {
      try {
        websocket.close();
      } catch (e) {
        console.error('WebSocketStream.close', e);
      }
    }
  }

  function send(method, obj) {
    const req = { method: method, params: [obj], id: ++callbackCounter };
    const deferred = new Deferred();
    promises[req.id] = deferred;
    websocket.send(JSON.stringify(req));
    return deferred;
  }

  function sendAck() {
    websocket.send(ackMessage);
  }

  function reset(clientInfo) {
    connectionDeferred = null;
    wssUrl = bcConfig.getWebSocketEndpoint();
    return _resetInner(clientInfo);
  }

  function _resetInner(clientInfo?) {
    if (clientInfo && clientInfo.WebSocketURL) {
      wssUrl = clientInfo.WebSocketURL;
    }
    lastReceivedMessageID = '0';
    return _reconnectInner();
  }

  function reconnect() {
    connectionDeferred = null;
    return _reconnectInner();
  }

  function _reconnectInner() {
    _innerClose();
    return _connect();
  }

  function _connect() {
    if (!connectionDeferred) {
      connectionDeferred = new Deferred();
    }

    _unsubscribeWebSocket();

    websocket = webSocketFactoryMethod(wssUrl);
    if (websocket) {
      websocket.onmessage = _onWebSocketMessage;
      websocket.onopen = _onWebSocketOpen;
      websocket.onerror = _onWebSocketError;
      websocket.onclose = _onWebSocketClose;
    } else {
      connectionDeferred.reject();
    }
    return connectionDeferred.promise;
  }

  function _onWebSocketOpen() {
    send('connect', { LastMessageID: lastReceivedMessageID });
  }

  function _onWebSocketError(err) {
    console.warn('WebSocket Error; ', err, 'TS: ' + Date.now());
    RxEmitterInstance.send('websocket-error', null);
  }

  function _onWebSocketClose(event) {
    console.warn('WebSocket Closed; ', event, 'TS: ' + Date.now());
    _unsubscribeWebSocket();
    websocket = null;

    if (connectionDeferred) {
      connectionDeferred.reject(event.reason || event.code);
    } else {
      self.onConnectionLost();
    }
  }

  function _unsubscribeWebSocket() {
    if (websocket) {
      websocket.onmessage = null;
      websocket.onopen = null;
      websocket.onerror = null;
      websocket.onclose = null;
    }
  }

  function _onWebSocketMessage(msg) {
    var data = msg.data;

    const obj = JSON.parse(data);

    if (!obj) {
      return;
    }

    if (obj.error) {
      throw new Error('DynamicQuery error: ' + obj.error);
    }

    if (obj.method) {
      var method = obj.method;
      var params = obj.params[0];
      _processMessage(method, params, obj.id, obj);
    } else {
      var id = obj.id;
      var promise = promises[id];
      if (promise) {
        promises[id] = null;
        promise.resolve(obj);
      }
    }
  }

  function _processMessage(method, params, id, data) {

    if (id && id !== '0') {
      lastReceivedMessageID = id;
    }

    var handler = messageHandlers[method];
    if (handler) {
      handler(method, params, id, data);
    } else {
      _messageCallback(method, params, id, data);
    }
  }

  var websocketReadyStates = {
    CONNECTING: 0,
    OPEN: 1,
    CLOSING: 2,
    CLOSED: 3
  };

  var promises = {};
  var callbackCounter = 0;
  var _messageCallback = null;

  var ackMessage = JSON.stringify({
    result: { Response: 'ack' },
    error: null,
    id: null
  });

  return self;
}
